import { render } from "./EmpresaInfo.vue?vue&type=template&id=25bdd1c1&scoped=true"
import script from "./EmpresaInfo.vue?vue&type=script&lang=js"
export * from "./EmpresaInfo.vue?vue&type=script&lang=js"

import "./EmpresaInfo.vue?vue&type=style&index=0&id=25bdd1c1&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25bdd1c1"]])

export default __exports__